import "../scss/styles.scss";
import PageDefault from "./pages/PageDefault";

export default class FactoryManager {
  static factory(cls) {
    return new FactoryManager.classes[cls]();
  }
}

FactoryManager.classes = { PageDefault };
